import { create } from 'zustand';
import { IUser } from 'api';

export type IUserStore = {
  user: IUser | null;
  setUser: (user: IUser | null) => void;
};

export const userStore = create<IUserStore>()(set => ({
  user: null,
  setUser: user => set({ user }),
}));
